import { styled } from 'styled-components';
import InputMask from 'react-input-mask';
import { styleInput } from './StyledInput';

export const StyledInputMask = styled(InputMask)`
    ${({ theme }) => styleInput(theme)}
`;
